import { getCookie } from "./cookies";
export default function authHeader() {
  const token = getCookie("vkconnectauth");
  if (token) {
    return { Authorization: "Bearer " + token };
  } else {
    return {};
  }
}
